const DEFAULT_API_BASE_URL = 'http://127.0.0.1:3001'

export function getApiBaseUrl() {
  const configuredUrl = import.meta.env.VITE_API_URL || DEFAULT_API_BASE_URL

  if (import.meta.env.DEV) {
    return configuredUrl.replace('://localhost:', '://127.0.0.1:')
  }

  return configuredUrl
}
